/*
 * Authors: mariushirjanu
 * Created: 20/05/2022
 */
import { Component } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';
import { HttpDataService, IHttpDataCache } from '../../../shared/http/http-data.service';

@Component({
  selector: 'cache-demo',
  template: `
    <h3>Cache</h3>
    This should cache the response of the http request until the cache is cleared
    <ol>
      <li *ngFor="let request of requests">{{request | json}}</li>
    </ol>
  `
})
export class CacheDemoComponent {
  private cache:IHttpDataCache<any>;
  public requests:IObject[] = [];

  constructor(
    httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
    const urlYesNo:string = '/ga2/rest/codesets/DOYESNO';
    
    const errorMessage:string = 'Error loading codesets';

    this.cache.doGET(urlYesNo, undefined, undefined, errorMessage)
      .then((response:Object[]) => {

        console.log('Request 1 (from server)', response);
        this.requests.push(response);
        this.cache.doGET(urlYesNo, undefined, undefined, errorMessage)
          .then((response:Object[]) => {

            console.log('Request 2 (from cache)', response);
            this.requests.push(response);
            this.cache.doGET(urlYesNo, undefined, undefined, errorMessage)
              .then((response:Object[]) => {

                console.log('Request 3 (from cache)', response);
                this.requests.push(response);
                this.cache.doGET(urlYesNo, undefined, undefined, errorMessage)
                  .then((response:Object[]) => {

                    console.log('Request 4 (from cache)', response);
                    this.requests.push(response);

                    // clear cache
                    this.cache.clear();
                    console.log('Cache cleared');

                    this.cache.doGET(urlYesNo, undefined, undefined, errorMessage)
                      .then((response:Object[]) => {

                        console.log('Request 5 (from server)', response);
                        this.requests.push(response);

                        this.cache.doGET(urlYesNo, undefined, undefined, errorMessage)
                          .then((response:Object[]) => {

                            console.log('Request 6 (from cache)', response);
                            this.requests.push(response);

                          });

                      });

                  });

              });

          });

      });

  }
}